module.exports = __webpack_public_path__ + "static/img/product_bg.59bf7209.jpg";